import { Routes } from '@angular/router';
import { byhoursHomeRootRoute, hotelsHomeRootRoute } from '@hotels/hotels-home/hotels-home-routing.module';
import { hotelDetailRootRoute } from '@hotels/hotel-detail/hotel-detail-routing.module';
import { hotelByhoursRootRoute, hotelResultsRootRoute } from '@hotels/hotel-results/hotel-results-routing.module';
import { ModuleCountryGuard } from '@app/services/guard/module-country.guard';
import { BYHOURS, HOTELS } from '@app/constants/route-titles.constants';
import { HeaderType } from '@design-system/components/templates/header/entities/header.types';
import { HeaderPageType, HeaderProductType } from '@header/entities/ds-header-config';
import { RoutingLevel } from '@ux/animations/animations';

export const hotelsAllModuleRoutes: Routes = [
  {
    path: hotelsHomeRootRoute, loadChildren: () =>
      import('../modules/hotels/hotels-home/hotels-home.module').then(m => m.HotelsHomeModule),
    data: {
      routingLevel: RoutingLevel.Two,
      dsHeaderConfig: {
        type: HeaderType.Generic,
        titleKey: HOTELS,
        pageType: HeaderPageType.SearchPage,
      },
    },
    canActivate: [ModuleCountryGuard]
  },
  {
    path: byhoursHomeRootRoute, loadChildren: () =>
      import('../modules/hotels/hotels-home/hotels-home.module').then(m => m.HotelsHomeModule),
    data: {
      routingLevel: RoutingLevel.Two,
      dsHeaderConfig: {
        type: HeaderType.Generic,
        titleKey: BYHOURS,
        pageType: HeaderPageType.SearchPage,
      },
    },
    canActivate: [ModuleCountryGuard]
  },
  {
    path: hotelResultsRootRoute, loadChildren: () =>
      import('../modules/hotels/hotel-results/hotel-results.module').then(m => m.HotelResultsModule),
    data: {
      routingLevel: RoutingLevel.Six,
      dsHeaderConfig: {
        type: HeaderType.Results,
        titleKey: null,
        pageType: HeaderPageType.ResultsPage,
        productType: HeaderProductType.Hotels,
      },
    },
    canActivate: [ModuleCountryGuard]
  },
  {
    path: hotelDetailRootRoute, loadChildren: () =>
      import('../modules/hotels/hotel-detail/hotel-detail.module').then(m => m.HotelDetailModule),
    data: {
      routingLevel: RoutingLevel.Seven,
      dsHeaderConfig: {
        type: HeaderType.FloatingRG,
        animatedType: HeaderType.Generic,
        titleKey: null,
        pageType: HeaderPageType.ResultDetailPage,
        productType: HeaderProductType.Hotels,
      },
    },
    canActivate: [ModuleCountryGuard]
  },
  {
    path: hotelByhoursRootRoute, loadChildren: () =>
      import('../modules/hotels/hotel-results/hotel-results.module').then(m => m.HotelResultsModule),
    data: {
      routingLevel: RoutingLevel.Six,
      isByhour: true,
      dsHeaderConfig: {
        type: HeaderType.Results,
        titleKey: null,
        pageType: HeaderPageType.ResultsPage,
        productType: HeaderProductType.ByHours,
      },
    },
    canActivate: [ModuleCountryGuard]
  },
];
